/* eslint-disable no-useless-escape */
import { z } from "zod";

import { ARABIC_TEXT_WITH_NUMBERS_REGEX } from "@/utils/constants/arabicRegex";

export const FilterItemSchema = z
  .object({
    id: z.string().optional(),
    value: z.array(z.string()).optional(),
  })
  .superRefine((data, ctx) => {
    if (data.id && (!data.value || data.value.length === 0)) {
      ctx.addIssue({
        path: ["value"],
        message: "Select at least one value for this filter",
        code: z.ZodIssueCode.custom,
      });
    }
    if (!data.id && data.value && data.value.length > 0) {
      ctx.addIssue({
        path: ["id"],
        message: "Select a filter",
        code: z.ZodIssueCode.custom,
      });
    }
  });

export const NewCategoryFormSchema = z
  .object({
    titleEn: z
      .string()
      .min(1, "Category name is required")
      .max(100, { message: "Category name must be under 100 characters." })
      .regex(/^[\w\s&’'\-\(\)]+$/, {
        message: "Invalid characters in category name.",
      })
      .trim(),
    titleAr: z
      .string()
      .min(1, "Category name is required")
      .max(100, "Tag name must not exceed 100 characters.")
      .regex(ARABIC_TEXT_WITH_NUMBERS_REGEX, {
        message:
          "Collection name must contain only Arabic characters and numbers.",
      })
      .trim(),
    subtitleEn: z
      .string()
      .min(1, "Description is required")
      .max(500, "Max length is 500 characters.")
      .trim(),
    subtitleAr: z
      .string()
      .min(1, "Description is required")
      .max(500, "Max length is 500 characters.")
      .regex(ARABIC_TEXT_WITH_NUMBERS_REGEX, {
        message: "Description must contain only Arabic characters and numbers.",
      })
      .trim(),

    type: z.string().min(1, { message: "Select a type" }),
    groupBy: z.string().optional().nullable(),
    brands: z.array(z.string()).optional(),
    filters: z.array(FilterItemSchema).optional(),
    mediaItemId: z.string().optional(),
    id: z.string().optional(),
    active: z.boolean().optional(),
    mediaItem: z
      .object({
        type: z.string(),
        url: z.string(),
      })
      .nullable()
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (data.type === "SELECTABLE_GROUP" && !data.groupBy) {
      ctx.addIssue({
        path: ["groupBy"],
        message: "Select a group by...",
        code: z.ZodIssueCode.custom,
      });
    }
  });

export type NewCategoryFormType = z.infer<typeof NewCategoryFormSchema>;
export type FilterItem = z.infer<typeof FilterItemSchema>;
